import { render, staticRenderFns } from "./SimpleAbsenceRequest.vue?vue&type=template&id=edd290c0&scoped=true&"
import script from "./SimpleAbsenceRequest.vue?vue&type=script&lang=js&"
export * from "./SimpleAbsenceRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd290c0",
  null
  
)

export default component.exports